<section>
  <p class="text-base font-medium">
    <span class="flex flex-row items-start">
      <p class="text-base font-medium">Predecessors</p>
      <a class="flex flex-row items-center gap-1" href="https://help.termsheet.com/add-predecessors" target="_blank">
        <ts-icon color="gray" icon="ts_question-circle" />
      </a>
      <div class="div w-full"></div>
      <ts-button
        iconTooltip="Add Predecessor"
        [attr.data-testid]="'task-details-predecessor-add-button'"
        color="accent"
        type="icon"
        icon="ts_plus"
        [disabled]="disabled"
        (click)="onManagePredecessors('add', taskPredecessorOptions)"
      />
    </span>
  </p>
  <mat-divider role="separator" class="mat-divider mt-1 mat-divider-horizontal mb-3" aria-orientation="horizontal">
  </mat-divider>
  @if (predecessors?.length > 0) {
    <div class="flex flex-col">
      @for (predecessor of predecessors; track predecessor.id; let even = $even) {
        <div
          [ngClass]="{ 'bg-black-50': even }"
          class="p-2 flex flex-row items-center justify-between cursor-pointer hover:bg-gray-200 transition"
          (click)="onManagePredecessors('edit', taskPredecessorOptions, predecessor)"
        >
          <div class="flex flex-row items-center gap-1">
            <a
              data-testid="navigate-to-task"
              class="flex flex-row items-center gap-1 cursor-pointer"
              (click)="onNavigateToTask($event, predecessor.predecessor_task_id)"
            >
              <ts-icon color="black" icon="open_in_new" />
            </a>
            <p class="truncate max-w-64">{{ predecessor?.title || 'Task ID: ' + predecessor.predecessor_task_id }}</p>
          </div>

          <div class="flex flex-row items-center gap-8">
            <p>{{ predecessor?.predecessor_type || '-' }}</p>
            <p class="w-7">{{ (predecessor?.lag | number: '1.0-0') + 'd' || '-' }}</p>
            <button
              data-testid="delete-predecessor"
              class="flex items-center"
              (click)="onRemovePredecessor($event, taskPredecessorOptions, predecessor)"
              [disabled]="disabled || !canEdit"
            >
              <ts-icon color="black" icon="ts_trash-alt" />
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    <p class="text-center">No predecessors created</p>
  }
</section>
